/**
 *
 * QuestionnaireEditCode
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  accentColorSecond,
  fontColorSecond,
  green,
  red,
  white,
} from '../../../../assets/styledAssets/vars';
import { Wrap } from '../../../../assets/styledAssets/grid';
import { TextArea } from '@progress/kendo-react-inputs';
import { StyledTransparentTxtArea } from '../QuestionnaireEdit/styles';
import Button from '../../../../components/Button/Button.component';
import QuestionnarieService from '../../../../service/Questionnarie.service';
import { Questionnaire } from '../../questionnaires';
import { useSnackbar } from 'notistack';

interface IProps {
  activeQuestionnaire?: Questionnaire;
}

const QuestionnaireEditCode: FunctionComponent<IProps> = ({
  activeQuestionnaire,
}) => {
  const intl = useIntl();
  const [script, setScript] = useState<string>('');
  const [errors, setErrors] = useState<string>('');
  const [isValid, setFormValid] = useState(true);
  const [disabledSave, setDisabledSave] = useState(true);
  const snackbar = useSnackbar();

  useEffect(() => {
    if (activeQuestionnaire?.id) {
      QuestionnarieService.getQuestionnaireScript(activeQuestionnaire.id).then(
        (res) => {
          setScript(res.script as string);
        },
      );
    }
  }, [activeQuestionnaire?.id]);

  const validate = () => {
    if (activeQuestionnaire?.id) {
      QuestionnarieService.questionnaireScriptVerify(
        activeQuestionnaire.id,
        script,
      )
        .then(() => {
          setFormValid(true);
          setDisabledSave(false);
          setErrors('');
        })
        .catch((res) => {
          setFormValid(false);
          setDisabledSave(true);
          setErrors(res.data);
        });
    }
  };

  const saveScript = () => {
    if (activeQuestionnaire?.id) {
      QuestionnarieService.questionnaireScriptCreate(
        activeQuestionnaire.id,
        script,
      ).then(() => {
        setDisabledSave(true);
        setErrors('');
        snackbar.enqueueSnackbar(intl.formatMessage(messages.scriptSaved), {
          variant: 'success',
        });
      });
    }
  };

  return (
    <Wrap flexDir={'column'} width={'100% '}>
      <Wrap
        br={'1rem'}
        bgColor={'transparent'}
        flexDir={'column'}
        borders={accentColorSecond}
        flexWrap={'nowrap'}
        width={'100%'}
        margin={'0 0 3rem 0'}
      >
        <Wrap color={fontColorSecond} fs={'2.4rem'} padding={'2rem'}>
          {'{...} C#'}
        </Wrap>
        <Wrap
          flexWrap={'nowrap'}
          flexDir={'column'}
          width={'100%'}
          br={'1rem'}
          bgColor={white}
          borders={accentColorSecond}
          padding={'2rem'}
        >
          <Wrap width={'100%'} fs={'2rem'} margin={'0 0 2rem 0'}>
            {intl.formatMessage(messages.addFormula)}
          </Wrap>
          <StyledTransparentTxtArea>
            <TextArea
              rows={8}
              value={script}
              onChange={(e) => {
                setScript(e.value as string);
                setDisabledSave(true);
              }}
            />
            <Wrap margin={'2rem 0 0 0'}>
              <Button primary onClick={validate}>
                {intl.formatMessage(messages.validate)}
              </Button>
              <Wrap margin={'0 0 0 2rem'}>
                <Button primary disabled={disabledSave} onClick={saveScript}>
                  {intl.formatMessage(messages.save)}
                </Button>
              </Wrap>
            </Wrap>
          </StyledTransparentTxtArea>
        </Wrap>
      </Wrap>
      <Wrap
        br={'1rem'}
        bgColor={isValid ? green : red}
        flexDir={'column'}
        borders={accentColorSecond}
        flexWrap={'nowrap'}
        width={'100%'}
        padding={'3rem 0 0 0'}
      >
        <Wrap
          flexWrap={'nowrap'}
          flexDir={'column'}
          width={'100%'}
          br={'1rem'}
          bgColor={white}
          borders={accentColorSecond}
          padding={'2rem'}
        >
          <StyledTransparentTxtArea>
            <Wrap margin={'1rem 0 2rem 0'} fs={'2rem'}>
              {intl.formatMessage(messages.formaulaIs)}{' '}
              {intl.formatMessage(isValid ? messages.valid : messages.invalid)}
            </Wrap>
            <Wrap fw={'bold'} style={{ whiteSpace: 'break-spaces' }}>
              {errors}
            </Wrap>
          </StyledTransparentTxtArea>
        </Wrap>
      </Wrap>
    </Wrap>
  );
};

export default memo(QuestionnaireEditCode);
